import { Users } from 'lucide-react'
import type { Team } from '../../../types/api.types'

export const UNASSIGNED_TEAM_ID = -1

interface TeamFilterPillsProps {
  teams: Team[]
  selectedTeamId: number | null
  onSelect: (teamId: number | null) => void
  showUnassigned: boolean
  onlineTeamIds: Set<number>
}

function pillClass(active: boolean, online: boolean): string {
  return `inline-flex shrink-0 items-center gap-1.5 rounded-full border px-3 py-1 text-xs font-medium transition-colors ${
    active
      ? 'border-brand-green bg-brand-green/5 text-gray-900'
      : 'border-gray-200 bg-white text-gray-700 hover:bg-gray-50'
  } ${online ? 'animate-pulse-green' : ''}`
}

export function TeamFilterPills({
  teams,
  selectedTeamId,
  onSelect,
  showUnassigned,
  onlineTeamIds,
}: TeamFilterPillsProps): JSX.Element | null {
  if (teams.length === 0 && !showUnassigned) return null

  function toggle(id: number): void {
    onSelect(selectedTeamId === id ? null : id)
  }

  return (
    <div className="mb-4 flex items-center gap-2">
      <Users size={14} className="shrink-0 text-gray-400" aria-hidden="true" />
      <div className="flex gap-4 overflow-x-auto px-1 py-1.5 [mask-image:linear-gradient(to_right,transparent,#000_16px,#000_calc(100%_-_16px),transparent)] [-webkit-mask-image:linear-gradient(to_right,transparent,#000_16px,#000_calc(100%_-_16px),transparent)]">
        {[...teams].sort((a, b) => +onlineTeamIds.has(b.id) - +onlineTeamIds.has(a.id)).map((team) => (
          <button
            key={team.id}
            type="button"
            onClick={() => toggle(team.id)}
            aria-pressed={selectedTeamId === team.id}
            className={pillClass(selectedTeamId === team.id, onlineTeamIds.has(team.id))}
          >
            {team.name}
          </button>
        ))}
        {showUnassigned && (
          <button
            type="button"
            onClick={() => toggle(UNASSIGNED_TEAM_ID)}
            aria-pressed={selectedTeamId === UNASSIGNED_TEAM_ID}
            className={pillClass(selectedTeamId === UNASSIGNED_TEAM_ID, false)}
          >
            Unassigned
          </button>
        )}
      </div>
    </div>
  )
}
